import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { connect } from 'react-redux';
import { editOutlet } from '../actions/EditOutlet';
const ConfigOutletElem = props => {
    return (_jsxs("div", { className: "config-outlet-elem", children: [_jsx("div", { children: props.name }), _jsx("div", { children: props.kind }), _jsx("div", { className: "pull-right", children: _jsx("button", { className: "editx lw xprimary small", onClick: () => props.onEditOutlet(), children: "\u00A0Redigera\u00A0" }) })] }));
};
const mapStateToProps = (state, ownProps) => {
    const outlet = state.definitions.outlets[ownProps.id];
    if (!outlet) {
        return {
            id: ownProps.id,
            kind: '',
            name: '',
            has_setup: false
        };
    }
    let kind;
    switch (outlet.kind) {
        case 'onoff':
            kind = 'På/Av';
            break;
        case 'dim':
            kind = 'Dimmer';
            break;
        case 'rollershade':
            kind = 'Rullgardin';
            break;
    }
    return {
        id: ownProps.id,
        name: outlet.title,
        kind,
        has_setup: outlet.kind == 'rollershade'
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        onEditOutlet: () => {
            dispatch(editOutlet(ownProps.id));
        }
    };
};
export const ConfigOutlet = connect(mapStateToProps, mapDispatchToProps)(ConfigOutletElem);
